import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import React from 'react';
import { colors } from '../../../../colorVars';
import TextButton from '../../../atomic/buttons/textButton/TextButton';
import { Body1, Body3 } from '../../../atomic/text/Text';
import style from './TradierLoginModal.module.css';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';

const brokerageLabels = {
  TRADIER: 'Tradier',
  TASTYTRADE: 'TastyTrade',
};

const openBrokerageLogin = (brokerage) => {
  const token = localStorage.getItem('jwt_token');
  if (!token) {
    alert('Please log in first before connecting your brokerage account.');
    return;
  }
  const baseUrl =
    window.config && window.config.REACT_APP_REDIRECT
      ? window.config.REACT_APP_REDIRECT
      : 'http://localhost:8080/';
  const params = new URLSearchParams({ token, brokerage });
  window.open(`${baseUrl}loginApp?${params.toString()}`, '_blank');
};

export const ConnectBrokerageModal = observer(({ open, handleClose, page }) => {
  const { applicationTypeStore } = useWebsocketStore();
  const isSecondaryApplication =
    applicationTypeStore.isSecondaryApplication ?? null;

  if (isSecondaryApplication && page === 'ALERTS')
    return (
      <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
        <div className={style.outerDiv}>
          <Body1 color={colors.lightGrey} fontWeight={700}>
            Brokerage Connection Required
          </Body1>
          <div className={style.text}>
            <Body3 color={colors.lightGrey} fontWeight={500}>
              In order to use this application, please connect a brokerage
              account.
            </Body3>
            <Body3 color={colors.lightGrey} fontWeight={500}>
              This can be done from your main Trade Unafraid interface using
              the fingerprint icon.
            </Body3>
          </div>
          <div className={style.buttons}>
            <TextButton
              width="35%"
              fontSize="medium"
              clickHandler={handleClose}
            >
              Ok
            </TextButton>
          </div>
        </div>
      </Modal>
    );
  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
      <div className={style.outerDiv}>
        <Body1 color={colors.lightGrey} fontWeight={700}>
          Connect Brokerage
        </Body1>
        <div className={style.text}>
          <Body3 color={colors.lightGrey} fontWeight={500}>
            Choose a brokerage to connect.
          </Body3>
          <Body3 color={colors.lightGrey} fontWeight={500}>
            You will be directed to another page where you can enter your
            credentials.
          </Body3>
          <Body3 color={colors.lightGrey} fontWeight={500}>
            This will give you access to market data necessary to use this
            application.
          </Body3>
        </div>
        <div className={style.buttons}>
          <TextButton
            width="35%"
            fontSize="medium"
            clickHandler={() => openBrokerageLogin('TRADIER')}
          >
            {brokerageLabels.TRADIER}
          </TextButton>
          <TextButton
            width="35%"
            fontSize="medium"
            clickHandler={() => openBrokerageLogin('TASTYTRADE')}
          >
            {brokerageLabels.TASTYTRADE}
          </TextButton>
          <TextButton
            width="35%"
            fontSize="medium"
            clickHandler={handleClose}
            backgroundColor={colors.red}
          >
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
});

ConnectBrokerageModal.propTypes = {
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  page: PropTypes.string,
};
